import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Input, InputGroup, InputGroupAddon, Row } from 'reactstrap';
import numeral from 'numeral';
import { flatten } from 'underscore';

import styles from '../form.module.scss';

const OPTIONS = {
  residential: [
    0, 100000, 150000, 200000, 250000, 300000, 350000, 400000, 450000, 500000, 600000,
    700000, 800000, 900000, 1000000, 1250000, 1500000, 1750000, 2000000, 3000000, 4000000
  ],
  residential_income: [
    0, 100000, 150000, 200000, 250000, 300000, 350000, 400000, 450000, 500000, 600000,
    700000, 800000, 900000, 1000000, 1250000, 1500000, 1750000, 2000000, 3000000, 4000000,
    5000000
  ]
};

function ListItem(props) {
  const isSelected = props.value === props.val;
  return (
    <li
      data-val={props.val}
      data-selected={isSelected}
      onClick={e => {
        props.onChange(props.val === 0 ? '' : props.val);
      }}
    >
      {props.children}
    </li>
  );
}

function Select(props) {
  const value = props.value !== '' ? parseInt(props.value, 10) : '';
  return (
    <Input
      {...props}
      type="select"
      value={value}
      onChange={e => {
        const val = e.target.value;
        props.onChange(val !== '' ? parseInt(val, 0) : val);
      }}
    >
      {props.children}
    </Input>
  );
}

class PriceFilter extends Component {
  static contextTypes = {
    theme: PropTypes.object
  };

  render() {
    const BS = this.context.theme;
    const { names, showSuggestions, showSelects, tabIndex, type } = this.props;

    const minPrice = this.props[names[0]],
      maxPrice = this.props[names[1]];

    const minPriceValue = minPrice.input.value
      ? numeral(minPrice.input.value).format('0,0')
      : '';
    const maxPriceValue = maxPrice.input.value
      ? numeral(maxPrice.input.value).format('0,0')
      : '';

    const options = this.props.options[type] || this.props.options;
    const flatOptions = flatten(options).sort((a, b) => a - b);

    return (
      <div>
        <Row>
          <Col xs={6}>
            <InputGroup>
              <InputGroupAddon
                tag="label"
                htmlFor="minPrice"
                addonType="prepend"
                className={styles.inlineInputGroupAddon}
              >
                $
              </InputGroupAddon>
              <Input
                {...minPrice.input}
                value={minPriceValue}
                placeholder="No Min"
                tabIndex={tabIndex}
                onBlur={e => {
                  minPrice.input.onBlur(numeral(e.target.value).value());
                }}
                onChange={e => {
                  e.stopPropagation();
                  minPrice.input.onChange(numeral(e.target.value).value());
                }}
              />
            </InputGroup>
            {showSuggestions && (
              <ul className={`${styles.inputList} ${BS.mt3}`}>
                {options.map((option, i) => (
                  <ListItem key={i} val={option[0]} {...minPrice.input}>
                    {numeral(option[0]).format('$0a')}
                  </ListItem>
                ))}
              </ul>
            )}
          </Col>
          <Col xs={6} className={BS.colDivider}>
            <InputGroup>
              <InputGroupAddon
                tag="label"
                htmlFor="maxPrice"
                addonType="prepend"
                className={styles.inlineInputGroupAddon}
              >
                $
              </InputGroupAddon>
              <Input
                {...maxPrice.input}
                value={maxPriceValue}
                placeholder="No Max"
                tabIndex={tabIndex ? tabIndex + 1 : tabIndex}
                onBlur={e => {
                  maxPrice.input.onBlur(numeral(e.target.value).value());
                }}
                onChange={e => {
                  maxPrice.input.onChange(numeral(e.target.value).value());
                }}
              />
            </InputGroup>
            {showSuggestions && (
              <ul className={`${styles.inputList} ${BS.mt3}`}>
                {options.map((option, i) => (
                  <ListItem key={i} val={option[1]} {...maxPrice.input}>
                    {numeral(option[1]).format('$0a')}
                  </ListItem>
                ))}
                <ListItem val={0} {...maxPrice.input}>
                  Any Price
                </ListItem>
              </ul>
            )}
          </Col>
        </Row>
        {showSelects && <div className={`${BS.mt2} ${BS.mb2} ${BS.textCenter}`}>Or</div>}
        {showSelects && (
          <Row>
            <Col xs={6}>
              <InputGroup>
                <Select {...minPrice.input}>
                  <option value="">From</option>
                  {flatOptions.map((val, i) => (
                    <option
                      key={i}
                      value={val}
                      disabled={maxPrice.input.value !== '' && maxPrice.input.value < val}
                    >
                      {numeral(val).format('$0,0')}
                    </option>
                  ))}
                </Select>
              </InputGroup>
            </Col>
            <Col xs={6} className={BS.colDivider}>
              <InputGroup>
                <Select {...maxPrice.input}>
                  <option value="">To</option>
                  {flatOptions.map((val, i) => (
                    <option
                      key={i}
                      value={val}
                      disabled={minPrice.input.value !== '' && minPrice.input.value > val}
                    >
                      {numeral(val).format('$0,0')}
                    </option>
                  ))}
                </Select>
              </InputGroup>
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

PriceFilter.defaultProps = {
  showSuggestions: false,
  showSelects: false,
  type: 'residential',
  options: OPTIONS
};

export { OPTIONS };
export default PriceFilter;



// WEBPACK FOOTER //
// ./src/components/form/filter/price-filter.js